import React from "react";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {IconEdit} from "components/icons";

export const SignContractOurProfileRow = ({profile, isOwner, onSelect, onEdit}) => (
  <div
    className={`modal-our-profiles__table-row${!!onSelect ? " cpointer" : ""}`}
    onClick={() => !!onSelect && onSelect(profile.id)}
  >
    <div className="modal-our-profiles__table-row-name">{profile.name}</div>
    <div className="modal-our-profiles__table-row-reference">
      {profile.intDesignation}
    </div>
    <div className="modal-our-profiles__table-row-company">{profile.companyName}</div>
    <div className="modal-our-profiles__table-row-number">{profile.companyNumber}</div>
    {isOwner && (
      <div className="modal-our-profiles__table-row-actions">
        <ButtonTransparent
          addClass="pa-0 mla"
          small
          noBorder
          icon={<IconEdit addClass="mr-0" />}
          onClick={(e) => {
            e.stopPropagation();
            onEdit(profile.id);
          }}
        />
      </div>
    )}
  </div>
);
